module.exports = __webpack_public_path__ + "img/tap-hand.1af9af39.svg";